import { IEvents, } from "@walletconnect/jsonrpc-types";
export class ISequence extends IEvents {
    constructor(client, logger) {
        super();
        this.client = client;
        this.logger = logger;
    }
}
//# sourceMappingURL=sequence.js.map